module.exports = __webpack_public_path__ + "img/loading.6ce69f2b.gif";